"use client";
import SVG from "react-inlinesvg";
import NewsList from "@/components/utils/NewsList";
import Accordion from "@/components/utils/Accordion";
import AnchorLink from "@/components/utils/AnchorLink";
import InViewAnimation from "@/components/utils/InViewAnimation";
import Link from "next/link";

export default function PageComponent({posts}) {
  return (
    <main className="page page-farmers">
      <InViewAnimation fadeOnly={true}>
        <div className="container-m">
          <section className="section section-kv">
            <div className="kv-pic pcOnly">
              <img src="/assets/img/for-farmers/kv-pic.jpg" alt="" />
            </div>
            <div className="kv-title-holder">
              <div className="shoulder">
                <span className="en small">For Farmers</span>
                <span className="bold">農家のみなさまへ</span>
              </div>
              <h1 className="h1-title bold">
                どんな農法の方でも<br className="spOnly" />取り入れられる。<br />
                収量を落とすことなく、<br />
                サステナブルな畑づくりと、<br />
                おいしく健康な野菜づくりへ。
              </h1>
              <div className="kv-pic spOnly">
                <img src="/assets/img/for-farmers/kv-pic.jpg" alt="" />
              </div>
              <div className="anchor-list">
                <AnchorLink href="#section-1" className="anchor-list-item scaleHover">
                  <span>
                    <i className="icon">
                      <SVG src="/assets/img/common/icon/icon-arrow-anchor.svg" />
                    </i>
                    Next Green Method | 3年で100年続く農業へ
                  </span>
                </AnchorLink>
                <AnchorLink href="#section-3" className="anchor-list-item scaleHover">
                  <span>
                    <i className="icon">
                      <SVG src="/assets/img/common/icon/icon-arrow-anchor.svg" />
                    </i>
                    Next Green Methodの3つのソリューション
                  </span>
                </AnchorLink>
                <div className="anchor-list-group">
                  <AnchorLink href="#section-3-1" className="anchor-list-item scaleHover">
                    <span>
                      Soil Solution｜おいしく育つ土づくり
                    </span>
                  </AnchorLink>
                  <AnchorLink href="#section-4-1" className="anchor-list-item scaleHover">
                    <span>
                      Agri LCA+｜土壌の価値の可視化
                    </span>
                  </AnchorLink>
                  <AnchorLink href="#section-5-1" className="anchor-list-item scaleHover">
                    <span>
                      Next Green Credit｜土づくりの好影響の価値化
                    </span>
                  </AnchorLink>
                </div>
                <AnchorLink href="#section-6" className="anchor-list-item scaleHover">
                  <span>
                    <i className="icon">
                      <SVG src="/assets/img/common/icon/icon-arrow-anchor.svg" />
                    </i>
                    Next Green Methodの導入プロセス
                  </span>
                </AnchorLink>
              </div>
            </div>
          </section>
        </div>

        <div className="separator-asterisk en">*</div>

        <section className="section section-1" id="section-1">
          <div className="block container-m">
            <div className="section-title-holder">
              <h2 className="section-title bold">
                <span className="small">Next Green Method</span>
                3年で自立安定的な<br className="spOnly" />農業へのシフトを実現する<br />
                ワンストップソリューション
              </h2>
              <div className="section-lead bold">
                おいしい野菜を育てる土をつくる「Soil Solution」、その土壌の価値を評価・可視化する「Agri LCA+」、さらに、その好影響を価値に変換し、経済的リターンとして還元することで、土づくりを資金的に支える「Next Green Credit」。<br />
                この3つのソリューションをワンストップで提供し、高収益でリスク耐性が高く、地球環境にとってもいい畑へのシフトを、3年で実現することを目指します。
              </div>
            </div>
            <picture className="pic n1">
              <source srcSet="/assets/img/for-farmers/section-1-1-pic.png" media="(min-width: 1024px)" />
              <source srcSet="/assets/img/for-farmers/section-1-1-pic-sp.png" media="(max-width: 1024px)" />
              <img src="/assets/img/for-farmers/section-1-1-pic.png" alt="" loading="lazy" />
            </picture>

            <h2 className="block-title bold">
              収益構造のシフト例
              <div className="small">*北海道のケース</div>
            </h2>

            <div className="bg-gray-block">
              <div className="scroll-area">
                <picture className="pic n2">
                  <source srcSet="/assets/img/for-farmers/section-1-2-pic.png" media="(min-width: 1024px)" />
                  <source srcSet="/assets/img/for-farmers/section-1-2-pic-sp.png" media="(max-width: 1024px)" />
                  <img src="/assets/img/for-farmers/section-1-2-pic.png" alt="" loading="lazy" />
                </picture>
              </div>
              <div className="text-holder">
                <p className="text bold">
                  ※ 農林水産省が公表する令和3年北海道畑作経営の農業経営収支、及び北海道の農家へのヒアリングを参考に、BG作成（2025年7月）。端数調整。
                </p>
                <p className="text bold">
                  【前提】<br />
                  栽培作物:畑作4品（小麦、大豆、馬鈴薯、甜菜）、面積30ha、プロジェクト期間7年間<br />
                  ベースライン：畑作4輪作、慣行基準の施肥管理<br />
                  プロジェクト活動：「Soil Next」1t を2年に1回施用、緑肥1.2tを4年に1回施用。　シナリオ1は化学肥料全品目80%削減、シナリオ2は化学肥料・農薬全品目80%削減
                </p>
              </div>
            </div>
          </div>
        </section>
      </InViewAnimation>
      
      <section className="section section-2" id="section-2">
        <div className="block n1 container-m">
          <div className="block-title bold">
            <Link className="scaleHover" href="/method/">
              <div className="inner pink underline">Next Green Method</div>
            </Link>を通じて、<br />生まれるさまざまなベネフィット
          </div>

          <h2 className="block-title bold">
            収益性の高い畑へ
          </h2>
          <div className="accordion-contianer-wrap col-3">
            <Accordion>
              <div className="accordion-title bold">
                収量を維持しながら<br />
                化学肥料削減
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  化学肥料効率が改善され、段階的に80%以上の肥料を減らすことが可能になり、大幅なコスト削減を可能にします。
                </div>
              </div>
            </Accordion>
            <Accordion>
              <div className="accordion-title bold">
                抗酸化力や栄養価の高い<br />
                おいしい野菜
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  多様性の高い生態系の中での生育とえぐみの元とも言われる窒素の投入量が減ることで、野菜本来の豊かな風味や旨みを感じられるとともに、抗酸化力や栄養価の高い野菜を育てることが可能になり、高い付加価値での取引へとつながります。
                </div>
              </div>
            </Accordion>
            <Accordion>
              <div className="accordion-title bold">
                クレジット収入による転換の<br />
                下支え
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  有機物の投入や、緑肥・カバークロップ、また化学肥料の削減による環境価値がクレジット収入として還元され、土づくり・畑の転換を下支えします。
                </div>
              </div>
            </Accordion>
          </div>
        </div>

        <div className="block n3 container-m">
          <h2 className="block-title bold">
            リスク耐性の高い畑へ
          </h2>
          <div className="accordion-contianer-wrap col-2">
            <Accordion>
              <div className="accordion-title bold">
                ️気候変動への順応性が向上
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  土壌の団粒化により保水性や透水性が向上することで、高温や干ばつ、多雨・小雨などの気候変動に対するレジリエンスが向上します。
                </div>
              </div>
            </Accordion>
            <Accordion>
              <div className="accordion-title bold">
                自立安定的
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  地域の有機物を活用したオールインワン有機発酵資材「Soil Next」の活用により、海外からの化学肥料や農薬への依存度が減り、為替や地政学リスクから自立した安定的な農業経営につながります。
                </div>
              </div>
            </Accordion>
          </div>
        </div>

        <div className="block n2 container-m">
          <h2 className="block-title bold">
            Agri LCA+で証明された<br className="spOnly" />環境価値の高い畑へ
          </h2>
          <div className="accordion-contianer-wrap col-3">
            <Accordion>
              <div className="accordion-title bold">
                地球温暖化を抑止
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  有機物を継続的に畑に投入することによって、長期間にわたり土壌に炭素を貯留します。また、窒素肥料を減らすことで、二酸化炭素の265倍もの温室効果を持つ一酸化二窒素の排出を削減し、地球温暖化の抑止に貢献します。
                </div>
              </div>
            </Accordion>
            <Accordion>
              <div className="accordion-title bold">
                水質の改善
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  化学肥料の削減や土壌の保肥力が向上することによって窒素やリンの水系への流出が軽減されるため、水質改善につながります。
                </div>
              </div>
            </Accordion>
            <Accordion>
              <div className="accordion-title bold">
                生態系の回復
                <i className="accordion-icon" />
              </div>
              <div className="accordion-content">
                <div className="accordion-text">
                  多様な有機物の投入、農薬の削減によって、土壌微生物を中心とした生態系の多様性が高まります。
                </div>
              </div>
            </Accordion>
          </div>
        </div>
      </section>

      <div className="separator-asterisk en">*</div>

      <section className="section section-3" id="section-3">
        <div className="container-m">

          <div className="section-title-holder" id="section-3-1">
            <h2 className="section-title bold">
              Next Green Methodの<br className="spOnly" />3つのソリューション
            </h2>
          </div>

          <picture className="pic-gallery round">
            <img src="/assets/img/for-farmers/gallery/pic-1.jpg" alt="" loading="lazy" />
          </picture>

          <div className="section-title-holder">
            <h2 className="section-title bold">
              Soil Solution
            </h2>
            <div className="section-lead bold">
              収量もしっかり維持しながら、<br />
              自然な多様性を持つ健康な土へ
            </div>
          </div>

          <div className="block n1 sticky-block-container grid-3-col reverse">
            <div className="sticky-item border block-title-holder">
              <div className="block-lead bold">
                自然界の多様な有機物とミネラルを発酵させた独自の有機発酵資材「Soil Next」を軸に、単一栽培となってしまう畑においても、自然界の多様な土壌生態系へと近づけていく。そうすることで、収量を維持しながら化学肥料や農薬を減らし、野菜はよりおいしく、地球環境への負荷は小さく、気候変動へのリスク耐性も高い自立安定的な農業へのシフトを可能にします。
              </div>
            </div>
            <div className="static-item sp-wide">
              <picture className="pic">
                <source srcSet="/assets/img/for-farmers/section-3-pic.png" media="(min-width: 1024px)" />
                <source srcSet="/assets/img/for-farmers/section-3-pic-sp.png" media="(max-width: 1024px)" />
                <img src="/assets/img/for-farmers/section-3-pic.png" alt="" loading="lazy" />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-4" id="section-4">
        <div className="container-m">
          <picture className="pic-gallery round">
            <img src="/assets/img/for-farmers/gallery/pic-2.jpg" alt="" loading="lazy" />
          </picture>

          <div className="section-title-holder" id="section-4-1">
            <h2 className="section-title bold">
              Agri LCA+
            </h2>
            <div className="section-lead bold">
              食べ手とつくり手の共通のものさしとなる、<br />
              土壌の価値を可視化する仕組み
            </div>
          </div>

          <div className="block n1 sticky-block-container grid-3-col reverse">
            <div className="sticky-item border block-title-holder">
              <div className="block-lead bold">
                農業に営み全体を総合的に評価することで、地球環境にも、おいしさや収量にも、よりよい農業を可視化する仕組み。これからの時代の本質的な「いい農業」「いい土」を示す指標があることで、食べ手は根拠を持って野菜を選びやすく、つくり手は感覚的ではなく明確な基準を持って農業活動に取り組むことが可能になります。
              </div>
            </div>
            <div className="static-item sp-wide">
              <picture className="pic">
                <source srcSet="/assets/img/for-farmers/section-4-pic.png" media="(min-width: 1024px)" />
                <source srcSet="/assets/img/for-farmers/section-4-pic-sp.png" media="(max-width: 1024px)" />
                <img src="/assets/img/for-farmers/section-4-pic.png" alt="" loading="lazy" />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-5" id="section-5">
        <div className="container-m">
          <picture className="pic-gallery round">
            <img src="/assets/img/for-farmers/gallery/pic-3.jpg" alt="" loading="lazy" />
          </picture>

          <div className="section-title-holder" id="section-5-1">
            <h2 className="section-title bold">
              Next Green Credit
            </h2>
            <div className="section-lead bold">
              日常の農業活動から生まれた<br className="spOnly" />環境価値が<br className="pcOnly" />クレジットとして<br className="spOnly" />新しい収入に
            </div>
          </div>

          <div className="block n1 sticky-block-container grid-3-col reverse">
            <div className="sticky-item border block-title-holder">
              <div className="block-lead bold">
                有機物やSoil Nextの投入、緑肥、化学肥料や農薬の削減、農業用水の節約や農業機械の利用削減など、土から健康な農業を目指すさまざまな農業活動によって生まれた価値が環境クレジットとして算出され、農作物以外の新たな収入源となります。
              </div>
            </div>
            <div className="static-item sp-wide">
              <picture className="pic">
                <source srcSet="/assets/img/for-farmers/section-5-1-pic.png" media="(min-width: 1024px)" />
                <source srcSet="/assets/img/for-farmers/section-5-1-pic-sp.png" media="(max-width: 1024px)" />
                <img src="/assets/img/for-farmers/section-5-1-pic.png" alt="" loading="lazy" />
              </picture>
            </div>
          </div>
          
          <div className="block n2">
            <h2 className="block-title bold">
              環境クレジットの収入例
            </h2>
            <div className="block-lead">
              <div className="bold">
                オールインワン有機発酵資材「Soil Next」の投入を含む4つの主要な農業活動から生まれる環境価値が、クレジットとして生産者に新たな収入をもたらします。
              </div>
              <div className="small">
                *北海道のケース
              </div>
            </div>
            <picture className="pic sp-wide">
              <source srcSet="/assets/img/for-farmers/section-5-2-pic.png" media="(min-width: 1024px)" />
              <source srcSet="/assets/img/for-farmers/section-5-2-pic-sp.png" media="(max-width: 1024px)" />
              <img src="/assets/img/for-farmers/section-5-2-pic.png" alt="" loading="lazy" />
            </picture>

            <div className="text-holder">
              <p className="text bold">
                ※ 2025年7月作成。端数調整。想定農家協力金単価は4万円/t-CO2（変更可能性有）。上記の算出された数値はあくまで参考値であり、気候・土壌条件、投入条件などによって変動します。
              </p>
              <p className="text bold">
                【前提】<br />
                栽培作物:畑作4品（小麦、大豆、馬鈴薯、甜菜）、面積30ha、プロジェクト期間7年間<br />
                ベースライン：畑作4輪作、慣行基準の施肥管理<br />
                プロジェクト活動：Action1は「Soil Next」1t を2年に1回施用、Action2はエンバク1.2tを4年に1回施用、Action3は化学肥料全品目80%減
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="separator-asterisk en">*</div>

      <section className="section section-6" id="section-6">
        <div className="container-m">
          <div className="section-title-holder">
            <h2 className="section-title bold">
              Next Green Methodの<br />
              導入プロセス
            </h2>
          </div>
          <div className="block n1">
            <picture className="pic">
              <source srcSet="/assets/img/for-farmers/section-6-pic.png" media="(min-width: 1024px)" />
              <source srcSet="/assets/img/for-farmers/section-6-pic-sp.png" media="(max-width: 1024px)" />
              <img src="/assets/img/for-farmers/section-6-pic.png" alt="" loading="lazy" />
            </picture>
          </div>
        </div>
      </section>

      {posts.length > 0 && (
        <>
          <div className="separator-asterisk en">*</div>

          <div className="container-m">
            <section className="section section-method-latestcase">
              <div className="section-title-holder">
                <h2 className="section-title bold">
                  最新事例
                </h2>
              </div>
              <div className="container-xs grayCard">
                <NewsList posts={posts} />
                <Link href="/news/implementation/farmers/" className="button-link button-round scaleHover size-s">
                  <span className="inner">すべての事例をみる</span>
                </Link>
              </div>
            </section>
          </div>
        </>
      )}
    </main>
  );
}
